import {
  GET_PDF_LIST_FAILURE,
  GET_PDF_LIST_SUCCESS,
  GET_PDF_METADATA_FAILURE,
  GET_PDF_METADATA_SUCCESS,
  GET_RESOURCE_FAILURE,
  GET_RESOURCE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE_SUCCESS,
} from "./resource.actionTypes";

const initialState = {
  resource: null,
  uploadedResource: null,
  pdfMetaData: null,
  pdfList: null,
  message: null,
};

export default function resourceReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        resource: payload,
        message: null,
      };
    case UPLOAD_FILE_FAILURE:
      return {
        ...state,
        message: payload.message,
      };

    case GET_RESOURCE_SUCCESS:
      return {
        ...state,
        uploadedResource: payload,
      };
    case GET_RESOURCE_FAILURE:
      return {
        ...state,
        message: payload.message,
      };

    case GET_PDF_METADATA_SUCCESS:
      return {
        ...state,
        pdfMetaData: payload.data,
      };
    case GET_PDF_METADATA_FAILURE:
      return {
        ...state,
        message: payload.message,
      };

    case GET_PDF_LIST_SUCCESS:
      return {
        ...state,
        pdfList: payload.data,
      };
    case GET_PDF_LIST_FAILURE:
      return {
        ...state,
        message: payload.message,
      };

    default:
      return state;
  }
}
